var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON DISCOVER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8342 2.10507C7.749 2.08233 1.97762 6.50396 2.00007 13.0828C2.02572 21.0651 7.90931 23.0632 11.8499 23.0632C15.7905 23.0632 22.3217 20.1717 22.3217 12.1894C22.3217 4.20705 15.7872 2.11806 12.8342 2.10507Z",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.88453 11.2601C9.88453 11.2601 14.3894 7.03337 15.5565 6.12695C15.3802 8.36214 14.1553 13.5407 14.1553 13.5407L8.34229 19.3399L9.88453 11.2601Z",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.88428 11.2603L14.1551 13.5409",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.e7cd0dab5bc4b7d454033d8c247d3eb1.svg";
export { ForwardRef as ReactComponent };